import useBootstrap from '../hooks/useBootstrap';
import useAuth from '../hooks/authentication/useAuth';
import React, { useEffect } from 'react';

export const BootstrapHandler: React.FC = () => {
    const bootstrap = useBootstrap();
    const { isLoggedIn } = useAuth();

    useEffect(() => {
        if (!isLoggedIn) {
            return;
        }
        bootstrap.fetch();
    }, [isLoggedIn]);

    return null;
};
